import { useWorkspace } from '../state/workspace';
import { StartPage } from '../views/StartPage';
import { UpdateNotice } from '../views/UpdateNotice';
import { Workspace } from '../views/Workspace';

export function App() {
  const hasSource = useWorkspace((s) => s.source !== null && s.error === null);
  return (
    <>
      {hasSource ? <Workspace /> : <StartPage />}
      <UpdateNotice />
    </>
  );
}
